export default {
    props: {
      value: {
        type: String
      }
    },
    data() {
      return {
        chosen: false
      }
    },
    computed: {
      chosen() {
        return this.$parent.value.indexOf(this.value) !== -1 ? true : false
      }
    },
    methods: {
      handleClick() {
        const parent = this.$parent
        const index = parent.value.indexOf(this.value)
        if (parent.multiple) {
          index === -1 ? parent.value.push(this.value) : parent.value.splice(index, 1)
        } else {
          parent.value = []
          parent.value.push(this.value)
          parent.show = false
        }
      }
    }
  }


/** WEBPACK FOOTER **
 ** ./src/Option.vue
 **/